import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IssuerAPIService } from '../services/issuer-api.service';
declare function BrowseObligorsponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function voiceForLastObligor(targetid): any;
declare function responsiveVoiceSpeak(title, innerText): any;
declare function VoiceOnKeyPress(value, key, eventId): any;
declare var $: any;
declare function btnToggleNew(): any;
declare function ShowErrorSnackbar(): any;
declare function ShowSnackbar_ForgotPasswordSuccess(): any;

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent implements OnInit {
  ForgotForm: FormGroup;
  public errorMessage: string = "";
  messagelist: any;
  loading: Boolean = true;
  submitted = false;
  showSuccessSnackbar = false;
  showFailureSnackbar = false;
  constructor(private formBuilder: FormBuilder, private IssuerAPI: IssuerAPIService) { }

  ngOnInit() {

    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }
    //============Voice Annotation On/Off=========
    if ($('#hidVoiceOnOff').val() == "OFF") {
      $('#btnVoiceAnnotation').val('OFF');
      $('#hidVoiceOnOff').val('OFF');
      $('#btnPlayPause').css('display', 'none');
    }
    else {
      $('#btnVoiceAnnotation').val('ON');
      $('#hidVoiceOnOff').val('ON');
      $('#btnPlayPause').css('display', 'block');
    }

    responsiveVoiceSpeak("", "This is Passwor forget page. Use tab to go to the next field."); 


    // add valiation to form 
    this.ForgotForm = this.formBuilder.group({
      username: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onkeypress(event: any) {
    debugger
    if ((event.target.id == "txtusername" || event.target.id == "txtuseremail")) {

      var username = $("#txtusername").val().trim();
      var useremail = $("#txtuseremail").val().trim();

      if (event.target.id == "txtuseremail" && event.keyCode == 9) {
       responsiveVoiceSpeak("", "Email Address. Please enter your Email address. This is a mandatory field. Use tab to go to the next field.");
      }

      if (event.target.id == "txtusername" && event.keyCode == 9) {
        responsiveVoiceSpeak("", "Username. Please enter your username. This is a mandatory field. Use tab to go to the next field.");
      }

      if ((event.target.id == "txtuseremail" || event.target.id == "txtusername") && (event.keyCode > 46)) {
        VoiceOnKeyPress(event.target.value, event.key, event.target.id);
      }

      if (username != "" && useremail != "") {

        this.loading = false;
      }
      else {
        this.loading = true;
      }
      return;
    }
  }

  onkeyup(event:any): void {
    this.showSuccessSnackbar = false;
    this.showFailureSnackbar = false;

      debugger;
    if (event.target.id == "txtuseremail" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Email Address. Please enter your Email address. This is a mandatory field. Use tab to go to the next field.");
    }

    if (event.target.id == "txtusername" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Username. Please enter your username. This is a mandatory field. Use tab to go to the next field.");
    }

    if (event.target.id == "lblForgetpassword" && event.keyCode == 9) {
      btnToggleNew();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblForgetpassword").innerText, "lblForgetpassword", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      //document.getElementById("onDemandWeb").focus();
      return;
    }
    if (event.target.id == "lblforget_Message" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblforget_Message").innerText, "lblforget_Message", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      //document.getElementById("onDemandWeb").focus();
      return;
    }
    if (event.target.id == "lblContactHead1" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblContactHead1").innerText, "lblContactHead1", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      //document.getElementById("onDemandWeb").focus();
      return;
    }
    if (event.target.id == "phonenumber" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("phonenumber").innerText, "phonenumber", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      //document.getElementById("onDemandWeb").focus();
      return;
    }
    if (event.target.id == "supportEmail" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("supportEmail").innerText, "supportEmail", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      //document.getElementById("onDemandWeb").focus();
      return;
    }
    if (event.target.id == "btnSubmit" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Submit button. Press enter to request for a password reset link or use tab to go to the next field.");
    }
    if (event.target.id == "btnSubmit" && event.keyCode ==13) {
      this.onSubmit();
    }
    if (event.target.id == "btnCancel" && event.keyCode == 13) {
      //this.router.navigate(['/mydac']);
      //responsiveVoiceSpeak("", "Cancel button. Press enter to return back to the login page or use tab to go to the footer..");
    }
    if (event.target.id == "btnCancel" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Cancel button. Press enter to return back to the login page or use tab to go to the footer.");
    }

    else if (event.keyCode == 27) {
      //if (event.target.id == "tdAlerts" || event.target.id == "tdobligorDesc" || event.target.id == "tdwebcasts" || event.target.id == "tdOverview" || event.target.id == "tdHistory" || event.target.id == "tdQA") {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      //}
    }

  }
  // convenience getter for easy access to form fields
  get f() { return this.ForgotForm.controls; }
  // validate and submit form controls 
  onSubmit() {
    debugger;
    this.submitted = true;
   // stop here if form is invalid
    if (this.ForgotForm.invalid) {
      var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
      if (!expr.test(this.ForgotForm.value.email)) {
        responsiveVoiceSpeak("", "Enter valid email");
        $("#txtuseremail").focus();
        return;
      }

      return;
    }

    const formValue = this.ForgotForm.value;
    this.IssuerAPI.SendForgotPassword_UserNameEmail(formValue.email, formValue.username).subscribe(data => {
      var response = data;
      if (response.success) {
        //this.showSuccessSnackbar = true;
        //this.showFailureSnackbar = false;
        $("#btnCancel").focus();
        responsiveVoiceSpeak("", response.message + ". Use enter to go to the login page or use tab to  go to the footer.");
        this.errorMessage = response.message;
        ShowSnackbar_ForgotPasswordSuccess();
        // setTimeout(function () { this.showSuccessSnackbar = false; }, 3000);
      }
      else {
        //this.showSuccessSnackbar = false;
        //this.showFailureSnackbar = true;
        $("#txtusername").val('');
        $("#txtuseremail").val('');
        $("#txtuseremail").focus();
        this.messagelist = response.errorMessages;
        ShowErrorSnackbar();
        //setTimeout(function () { this.showFailureSnackbar = false; }, 3000);
        responsiveVoiceSpeak("", (this.messagelist ? this.messagelist.join("\n") : "") + "\nPlease enter your email address and username again.");
      }

    });

  }
}

